import { render, staticRenderFns } from "./WQDataRecordForm.vue?vue&type=template&id=d8862b68"
import script from "./WQDataRecordForm.vue?vue&type=script&lang=js"
export * from "./WQDataRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports